import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { cadastro } from '../services/api';

export default function Cadastro() {
  const [form, setForm] = useState({ nome: '', email: '', telefone: '', senha: '' });
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');
  const { loginUser } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (!form.nome || !form.email || !form.senha) return setErro('Preencha todos os campos obrigatórios');
    if (form.senha.length < 6) return setErro('Senha deve ter mínimo 6 caracteres');
    setLoading(true); setErro('');
    try {
      const r = await cadastro(form);
      loginUser(r.data.token, r.data.usuario);
      navigate('/');
    } catch (e) {
      setErro(e.response?.data?.error || 'Erro ao criar conta');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ padding: 20 }}>
      <div style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 12, padding: 24, marginTop: 20 }}>
        <h1 style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: 28, color: 'var(--red)', marginBottom: 4 }}>CRIAR CONTA</h1>
        <p style={{ fontSize: 13, color: 'var(--text2)', marginBottom: 20 }}>Grátis! Ganhe pontos e promoções 🎉</p>
        {erro && <div style={{ background: 'rgba(230,48,48,.15)', border: '1px solid rgba(230,48,48,.3)', color: 'var(--red)', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 14 }}>{erro}</div>}
        {[['Nome completo *', 'nome', 'text', 'Seu nome'], ['E-mail *', 'email', 'email', 'seu@email.com'], ['Telefone', 'telefone', 'tel', '(11) 99999-9999'], ['Senha *', 'senha', 'password', 'Mínimo 6 caracteres']].map(([label, field, type, placeholder]) => (
          <div className="input-group" key={field}>
            <label className="input-label">{label}</label>
            <input className="input-field" type={type} placeholder={placeholder} value={form[field]} onChange={e => setForm(p => ({ ...p, [field]: e.target.value }))} />
          </div>
        ))}
        <button className="btn-primary" onClick={handleSubmit} disabled={loading}>{loading ? '⏳ Criando conta...' : 'Criar conta grátis →'}</button>
        <p style={{ textAlign: 'center', marginTop: 16, fontSize: 13, color: 'var(--text2)' }}>
          Já tem conta? <Link to="/login" style={{ color: 'var(--orange)' }}>Entrar</Link>
        </p>
      </div>
    </div>
  );
}
